module.exports = __webpack_public_path__ + "static/media/css.fab234c5.webp";